import { api, type SectionDraftDetail, type SectionPhotoOptions } from '../../api/client'

const SD = '/api/lab/section-drafts'

/** Every photograph the piece's own sources hold, of the subject first. */
export const getPhotoOptions = (id: number) => api.get<SectionPhotoOptions>(`${SD}/${id}/photo-options`)

/** Use an archive photograph; the server re-derives its credit. */
export const choosePhoto = (id: number, assetId: number) => api.post<SectionDraftDetail>(`${SD}/${id}/photo/${assetId}`)

/** A photograph the archive cannot supply. The credit is optional (blank = uncredited). */
export function uploadPhoto(id: number, file: File, credit: string) {
  const fd = new FormData()
  fd.append('file', file)
  fd.append('credit', credit)
  return api.postForm<SectionDraftDetail>(`${SD}/${id}/photo`, fd)
}

/** Take the photograph off the piece (and off the live piece when published); its credit goes too. */
export const removePhoto = (id: number) => api.del<SectionDraftDetail>(`${SD}/${id}/photo`)

/** A published piece's photo credit, pushed to the site. `null` pushes the caption already resolved. */
export const pushPhotoCredit = (id: number, caption: string | null) =>
  api.post<SectionDraftDetail>(`${SD}/${id}/photo-credit`, { caption })
